import { Controller } from "@hotwired/stimulus"
import { measure } from "./layout_measurement"

// Swaps a button/link's own full label down to just its first word ("Rotate API key" -> "Rotate",
// "Compare plans" -> "Compare") the moment the full label would actually overflow its own box,
// not on a guessed screen-size breakpoint: the same "does this actually overflow" check
// sub_nav_scroll_controller.js already uses for the sub-nav's own arrows, here applied to a single
// button's own label instead of a whole row of nav items. See the CSS: this element and its own
// .short-label-full span are both set up (overflow: hidden; white-space: nowrap) specifically so
// scrollWidth/clientWidth actually differ the moment the full label doesn't fit on one line,
// rather than silently wrapping onto a second line the way plain text would otherwise. See
// layout_measurement.js for why the actual read is batched across every button like this one on
// the page, not measured independently as each one connects.
//
// Both spans render every time, the short one starting hidden in the markup itself: if JS never
// runs at all, this degrades to showing the full label forever, never to showing nothing.
export default class extends Controller {
  static targets = ["full", "short"]

  connect() {
    this.update = this.update.bind(this)
    this.update()
    window.addEventListener("resize", this.update)
  }

  disconnect() {
    window.removeEventListener("resize", this.update)
  }

  update() {
    // Reset to the full label before (re-)measuring; a previous run's own short label hidden in
    // its place would leave nothing wide left to overflow.
    this.fullTarget.hidden = false
    this.shortTarget.hidden = true

    measure(this.element, (el) => el.scrollWidth > el.clientWidth + 1, (overflowing) => {
      this.fullTarget.hidden = overflowing
      this.shortTarget.hidden = !overflowing
    })
  }
}
